export const categories = [
  { id: "tahouse", name: "塌房现场", slug: "tahouse", description: "明星网红塌房事件实时追踪", icon: "ri-alert-fill" },
  { id: "celebrity", name: "明星黑料", slug: "celebrity", description: "娱乐圈明星最新黑料爆料", icon: "ri-star-fill" },
  { id: "wanghong", name: "网红大瓜", slug: "wanghong", description: "网红圈劲爆大瓜一网打尽", icon: "ri-user-smile-fill" },
  { id: "exclusive", name: "独家深扒", slug: "exclusive", description: "独家深度调查与内幕揭秘", icon: "ri-search-eye-line" },
  { id: "video", name: "爆料视频", slug: "video", description: "黑料实锤视频合集", icon: "ri-video-fill" },
  { id: "gossip", name: "圈内八卦", slug: "gossip", description: "娱乐圈最新八卦资讯", icon: "ri-chat-smile-2-fill" },
];

export const articles = [
  {
    id: 1,
    slug: "top-wanghong-zhang-san-collapse",
    title: "顶流网红张三深夜发文承认造假，千万粉丝账号一夜崩塌",
    summary: "拥有3000万粉丝的顶流网红张三在凌晨发布长文，承认此前多个直播内容存在剧本造假行为，引发全网震动。据知情人士透露，其背后的MCN机构已紧急启动危机公关。",
    content: `<p>7月6日凌晨2点，拥有3000万粉丝的顶流网红张三在其社交账号发布了一篇长达2000字的道歉声明，承认此前多个爆款直播内容存在剧本造假行为。这篇深夜发出的长文，如同一颗重磅炸弹，瞬间引爆了整个网络。</p>
<p>据张三在道歉声明中自述，过去两年间，其团队策划了至少15场"即兴"直播冲突事件，包括街头偶遇明星、路人恶意挑衅等爆款内容，实际上全部由团队精心编排。张三表示："我辜负了每一位粉丝的信任，这些虚假内容不仅欺骗了大家的情感，也严重损害了直播行业的公信力。"</p>
<p>消息传出后，张三的粉丝数量在短短6小时内暴跌超过500万。#张三造假#话题迅速登顶微博热搜，累计阅读量突破8亿。多个品牌方连夜发布声明，宣布终止与张三的代言合作。</p>
<p>业内知情人士向本网透露，张三背后的MCN机构"星光传媒"已在第一时间启动危机公关，但目前局势已超出可控范围。据悉，市场监管部门也已介入调查，关注其是否存在虚假宣传和欺诈消费者的行为。</p>
<p>值得注意的是，就在事件爆发前一周，张三刚刚在一档访谈节目中信誓旦旦地表示"我的每一场直播都是真实的、即兴的"。这段视频目前正在各大平台被网友疯狂转发和嘲讽。</p>`,
    category: "wanghong",
    tags: ["张三", "直播造假", "网红塌房", "MCN"],
    coverImageSeq: "cover-art-01",
    coverImagePrompt: "A minimalist dramatic scene with a single smartphone screen glowing in complete darkness on a wooden desk, the screen showing a cracked social media profile page with rapidly dropping follower count numbers in red, surrounded by scattered gossip magazine clippings, moody atmospheric lighting with deep shadows, editorial photography style, warm amber and deep charcoal tones, high contrast, cinematic composition, 4K quality",
    thumbnailPrompt: "Minimalist close-up shot of a smartphone displaying a cracked social media profile with a red declining follower counter, lying on a dark wooden surface, dramatic side lighting casting long shadows, moody editorial atmosphere, warm amber tones with deep blacks, cinematic depth of field, clean simple background",
    publishedAt: "2026-07-06T02:30:00Z",
    views: 12850000,
    comments: 89200,
    author: "吃瓜前线记者",
    isHot: true,
    isBreaking: true,
  },
  {
    id: 2,
    slug: "actress-li-si-secret-marriage",
    title: "一线女星李四被曝隐婚三年，丈夫竟是圈外低调富豪",
    summary: "狗仔队拍到李四与一名神秘男子同进同出高档小区，经深扒发现二人已秘密登记结婚三年。男方被扒出是某科技公司创始人，身价超过50亿。",
    content: `<p>娱乐圈再爆重磅消息！一线女星李四被知名狗仔拍到与一名神秘男子频繁出入北京某高档小区，两人举止亲密，毫不避讳。经过深入调查，本网独家获悉，李四与该男子已秘密登记结婚三年之久。</p>
<p>据知情人士透露，李四的丈夫王某是某知名科技公司的创始人兼CEO，身价超过50亿元人民币。两人是在一次慈善晚宴上经共同朋友介绍认识的，相恋半年后低调领证。由于李四正处于事业上升期，双方决定暂不公开婚讯。</p>
<p>相关房产记录显示，二人共同持有的北京朝阳区一处豪宅市值超过8000万元。此外，两人还共同持有多处海外房产。</p>
<p>李四的经纪团队目前对此事保持沉默，未做任何回应。粉丝们则在社交媒体上展开了激烈讨论，大部分粉丝表示祝福，但也有不少粉丝对偶像隐瞒婚姻的行为表示失望。</p>`,
    category: "celebrity",
    tags: ["李四", "隐婚", "富豪", "娱乐圈"],
    coverImageSeq: "cover-art-02",
    coverImagePrompt: "A minimalist elegant wedding ring resting on a torn confidential document with red 'CONFIDENTIAL' stamp visible, placed on a white marble surface, soft natural window light from the side creating gentle shadows, scattered rose petals in the corner, sophisticated and mysterious editorial photography, cream and ivory tones with subtle gold accents, shallow depth of field, clean aesthetic composition, 4K quality",
    thumbnailPrompt: "A single elegant wedding ring placed on a torn confidential document with a red stamp, resting on white marble, soft side lighting from a window, mysterious and sophisticated atmosphere, cream and ivory tones, shallow depth of field, clean minimalist composition",
    publishedAt: "2026-07-05T14:00:00Z",
    views: 9650000,
    comments: 65400,
    author: "深扒小能手",
    isHot: true,
    isBreaking: true,
  },
  {
    id: 3,
    slug: "idol-group-wang-wu-drug-scandal",
    title: "偶像男团成员王五涉毒被警方带走，所属组合宣布无限期停摆",
    summary: "警方突袭某私人派对，当场抓获多名涉毒人员，其中包括人气偶像男团成员王五。消息传出后其所属组合官方宣布无限期暂停所有活动。",
    content: `<p>7月5日晚间，北京市公安局朝阳分局在一次突击检查中，在某高档私人会所内抓获多名涉毒人员。令人震惊的是，其中一人正是当下人气偶像男团"流星少年"的核心成员王五。</p>
<p>据警方通报，现场查获多种违禁药物及吸毒工具。王五的尿检结果呈阳性，目前已被依法采取强制措施。案件正在进一步侦办中。</p>
<p>消息传出后，"流星少年"所属经纪公司"华星娱乐"于今日凌晨发布紧急声明，宣布该组合即日起无限期暂停所有演艺活动，包括原定于本月底的五万人演唱会。声明中表示："公司对此事深感震惊和痛心，将全力配合警方调查，并向一直以来支持我们的粉丝致以最诚挚的歉意。"</p>
<p>王五个人的多个品牌代言已被紧急下架，包括某国际运动品牌和某高端护肤品牌的广告已在各大平台消失。业内人士估算，此次事件造成的直接经济损失可能超过2亿元人民币。</p>`,
    category: "tahouse",
    tags: ["王五", "涉毒", "偶像塌房", "流星少年"],
    coverImageSeq: "cover-art-03",
    coverImagePrompt: "A minimalist scene of a shattered stage spotlight lying on a dark floor with broken glass fragments scattered around, a microphone fallen nearby, dramatic single overhead light casting harsh shadows, backstage atmosphere, cold blue and dark grey tones, editorial photography with high contrast, somber and powerful composition, 4K quality, clean simple background",
    thumbnailPrompt: "A shattered spotlight on a dark stage floor with broken glass and a fallen microphone nearby, dramatic overhead lighting with harsh shadows, cold blue-grey tones, powerful and somber editorial atmosphere, clean composition",
    publishedAt: "2026-07-05T20:00:00Z",
    views: 18700000,
    comments: 123000,
    author: "吃瓜前线记者",
    isHot: true,
    isBreaking: true,
  },
  {
    id: 4,
    slug: "streamer-zhao-liu-tax-evasion",
    title: "直播带货一姐赵六被曝偷税漏税2.8亿，直播间已成空",
    summary: "税务部门公布重大偷逃税案件，知名带货主播赵六在2023至2025年间偷逃个人所得税及增值税合计2.8亿元，其直播间已被平台封禁。",
    content: `<p>国家税务总局今日公布一起重大偷逃税案件。知名直播带货主播赵六在2023年至2025年期间，通过隐匿个人收入、虚构业务转换收入性质等方式，偷逃个人所得税及增值税合计2.8亿元人民币。</p>
<p>根据税务部门披露的信息，赵六在这两年间实际取得直播带货佣金、品牌代言费等收入超过6亿元，但其通过设立多家空壳公司、签订虚假合同等手段，将个人收入伪装为企业经营收入，从而适用较低的税率。</p>
<p>目前，税务部门已依法对赵六追缴税款、加收滞纳金并处罚款，合计3.92亿元。赵六的主要直播平台已将其直播间永久封禁，其个人社交账号也被限制功能。</p>
<p>这已是今年第三起头部主播偷逃税被曝光的案例。行业分析师指出，这反映出直播电商行业在高速增长背后存在的税务合规问题亟待解决。</p>`,
    category: "wanghong",
    tags: ["赵六", "偷税漏税", "直播带货", "封禁"],
    coverImageSeq: "cover-art-04",
    coverImagePrompt: "A minimalist top-down view of a calculator, scattered tax forms with red ink marks, and a stack of money partially covered by an official government seal document, arranged on a dark grey desk surface, harsh fluorescent lighting from above creating stark shadows, cold and clinical atmosphere, editorial photography style, muted grey and red accent tones, 4K quality, clean simple composition",
    thumbnailPrompt: "Top-down view of a calculator with tax forms and red-stamped documents on a dark grey desk, harsh overhead lighting, cold clinical atmosphere, muted grey tones with red accents, editorial style, clean composition",
    publishedAt: "2026-07-04T10:00:00Z",
    views: 11200000,
    comments: 78900,
    author: "财经深扒组",
    isHot: true,
    isBreaking: false,
  },
  {
    id: 5,
    slug: "actor-zhou-qi-affair-exposed",
    title: "实力派演员周七出轨实锤，与女助理酒店共度三夜",
    summary: "知名狗仔曝光周七在妻子怀孕期间与年轻女助理在酒店约会，连续三天被拍到同进同出。周七此前一直以「好丈夫」人设著称。",
    content: `<p>知名狗仔"娱乐追击令"今日放出重磅实锤，曝光实力派演员周七在其妻子怀孕期间，与一名年轻女助理在酒店约会三天的完整视频。视频显示，两人连续三天同进同出某五星级酒店，举止亲密。</p>
<p>周七此前一直以"好丈夫""顾家男人"的人设深入人心，经常在公开场合谈论家庭的重要性，社交账号上也频繁晒出与妻子的恩爱照片。此次出轨实锤的曝光，让人设瞬间崩塌。</p>
<p>据知情人透露，该女助理今年25岁，去年刚刚入职周七的工作室。两人在工作中逐渐产生感情，工作室的多名员工早已察觉异常，但碍于周七的地位一直无人敢说。</p>
<p>周七的妻子是圈外人，目前正怀着二胎，预产期就在下个月。消息人士称，其妻子看到新闻后情绪崩溃，已被家人接回娘家。</p>`,
    category: "tahouse",
    tags: ["周七", "出轨", "人设崩塌", "好丈夫"],
    coverImageSeq: "cover-art-05",
    coverImagePrompt: "A minimalist scene of a wedding ring sitting alone on a hotel nightstand next to a room key card, soft diffused window light filtering through sheer curtains, the background showing a blurred unmade hotel bed, melancholic and intimate atmosphere, editorial photography with muted warm tones and subtle teal shadows, deeply emotional composition, 4K quality, clean simple setting",
    thumbnailPrompt: "A wedding ring on a hotel nightstand beside a key card, soft window light through sheer curtains, blurred unmade bed in background, melancholic editorial atmosphere, muted warm tones with teal shadows, clean composition",
    publishedAt: "2026-07-04T08:00:00Z",
    views: 15300000,
    comments: 98700,
    author: "娱乐追击令",
    isHot: true,
    isBreaking: false,
  },
  {
    id: 6,
    slug: "singer-wu-jiu-contract-dispute",
    title: "知名歌手吴九控诉经纪公司霸王条款，双方对簿公堂",
    summary: "歌手吴九在社交媒体发布长文，控诉其签约的经纪公司存在严重霸王条款，要求其每年完成300场商演。经纪公司反诉其违约，索赔8000万。",
    content: `<p>知名歌手吴九今日在微博发布3000字长文，公开控诉其签约经纪公司"天音娱乐"存在严重的不平等合约条款。吴九表示，其合同中规定每年必须完成300场商演，平均每天接近一场，严重超出合理范围。</p>
<p>吴九在长文中晒出了多份合同截图，显示其签约时仅获得总收入的15%，而经纪公司拿走85%。此外，合同中还规定吴九的社交账号、音乐版权等均归公司所有，甚至其私人微信账号的密码也被公司掌控。</p>
<p>天音娱乐随即发布声明，否认所有指控，并反诉吴九违反独家经纪合约，擅自接洽外部商演活动，索赔违约金8000万元。目前案件已进入司法程序。</p>
<p>多位娱乐圈人士发声支持吴九，呼吁行业重视艺人权益保护。著名音乐人陈某在转发中写道："这不是个案，这是整个行业的痼疾。"</p>`,
    category: "exclusive",
    tags: ["吴九", "经纪公司", "霸王条款", "法律纠纷"],
    coverImageSeq: "cover-art-06",
    coverImagePrompt: "A minimalist close-up of a pen lying across a heavily redacted contract document with large black marker lines crossing out paragraphs, dramatic side lighting from a desk lamp creating strong contrast, ink splatters on white paper, tense and confrontational atmosphere, editorial photography in stark black and white with warm desk lamp glow, 4K quality, clean composition",
    thumbnailPrompt: "A pen across a heavily redacted contract with black marker lines, dramatic desk lamp side lighting, stark black and white with warm glow, tense editorial atmosphere, clean composition",
    publishedAt: "2026-07-03T16:00:00Z",
    views: 7890000,
    comments: 54300,
    author: "深度调查组",
    isHot: false,
    isBreaking: false,
  },
  {
    id: 7,
    slug: "variety-show-rigging-exposed",
    title: "热门综艺被曝剧本操控，淘汰环节全由导演组内定",
    summary: "一位离职员工匿名爆料，某卫视王牌综艺节目的淘汰结果全部由导演组提前安排，选手的排名和晋级路径在节目录制前就已确定。",
    content: `<p>一则来自某卫视综艺节目离职员工的匿名爆料，揭开了综艺节目制作背后的黑幕。据该员工透露，该卫视的一档王牌选秀综艺中，所有的淘汰结果、选手排名和晋级路径均在节目录制前就已由导演组和赞助商共同确定。</p>
<p>爆料人提供了多份内部工作文档，清晰记录了"淘汰安排表"和"选手人设规划"。文档中详细标注了每位选手的"剧本走向"，包括谁在第几期被淘汰、谁将获得"逆袭剧本"、谁被安排"卖惨故事线"等。</p>
<p>更令人震惊的是，赞助商对淘汰结果拥有否决权。爆料文档显示，某赞助商曾因一位人气选手代言了竞品品牌，直接要求导演组提前将其淘汰。</p>
<p>该爆料在网络上引发轩然大波。众多曾经真情实感追过这档节目的观众表示"被欺骗了感情"。</p>`,
    category: "gossip",
    tags: ["综艺", "剧本操控", "选秀", "内幕"],
    coverImageSeq: "cover-art-07",
    coverImagePrompt: "A minimalist backstage view of a television studio control room through a slightly opened door, showing multiple monitor screens displaying stage performances, a clipboard with 'SCRIPT' visible resting on the console, cables and equipment in the foreground slightly out of focus, dim blue ambient lighting from the monitors, mysterious and revealing atmosphere, editorial photography with cinematic color grading, deep blues and muted warm tones, 4K quality",
    thumbnailPrompt: "A TV studio control room seen through a slightly open door, monitors showing performances, clipboard labeled 'SCRIPT' on console, dim blue ambient light, mysterious editorial atmosphere, cinematic tones, clean composition",
    publishedAt: "2026-07-03T12:00:00Z",
    views: 10200000,
    comments: 71200,
    author: "圈内老炮",
    isHot: false,
    isBreaking: false,
  },
  {
    id: 8,
    slug: "influencer-chen-ba-fake-charity",
    title: "百万粉网红陈八被曝假慈善，募捐款项去向不明",
    summary: "网红陈八曾在直播间号召粉丝为山区儿童捐款，筹集超500万元。但记者实地走访发现，其声称资助的多所学校并未收到任何款项。",
    content: `<p>拥有800万粉丝的公益类网红陈八，近日被质疑其发起的多个慈善项目存在资金去向不明的问题。本网记者实地走访了陈八声称资助的多所山区学校，发现情况与其直播中描述的大相径庭。</p>
<p>陈八在过去一年间，多次在直播间发起"山区助学"募捐活动，累计筹集善款超过500万元。其直播中展示了多所受助学校的照片和视频，声称款项已用于改善学校设施和资助贫困学生。</p>
<p>然而，记者实地走访了云南、贵州等地的5所受助学校后发现，其中3所学校从未收到过任何来自陈八或其团队的捐款，另外2所学校仅收到过少量物资，价值不超过5万元。</p>
<p>多位学校负责人向记者证实，陈八团队确实曾到学校拍摄过素材，但拍完之后就离开了，并未落实任何资助承诺。目前，民政部门表示已关注此事，将依法展开调查。</p>`,
    category: "tahouse",
    tags: ["陈八", "假慈善", "捐款", "诈骗"],
    coverImageSeq: "cover-art-08",
    coverImagePrompt: "A minimalist overhead shot of a transparent empty donation box placed on a rustic wooden school desk in a dimly lit classroom, chalkboard with faded writing in the background, a single ray of sunlight streaming through a dusty window illuminating the empty box, poignant and revealing atmosphere, editorial photography with warm golden light against cool dark shadows, emotional and powerful composition, 4K quality",
    thumbnailPrompt: "Overhead view of an empty transparent donation box on a rustic school desk, single sunbeam through dusty window, poignant atmosphere, warm golden light against dark shadows, powerful editorial composition",
    publishedAt: "2026-07-02T18:00:00Z",
    views: 14500000,
    comments: 105000,
    author: "调查记者组",
    isHot: false,
    isBreaking: false,
  },
  {
    id: 9,
    slug: "director-sun-shi-plagiarism",
    title: "新锐导演孙十新片陷入抄袭风波，被扒多处雷同",
    summary: "即将上映的电影「暗夜追光」被网友扒出与三部韩国电影存在大量相似镜头和剧情设定。导演孙十回应称「致敬」，网友不买账。",
    content: `<p>即将于暑期档上映的电影《暗夜追光》在上周发布预告片后，迅速引发争议。眼尖的网友发现，预告片中的多处镜头构图、场景布置和剧情设定与三部韩国电影高度雷同。</p>
<p>微博用户@电影显微镜 发布了一组详细对比图，将《暗夜追光》预告片中的画面与韩国电影《燃烧》《寄生虫》《老男孩》进行逐帧对比，指出至少17处存在明显相似的镜头和场景。该对比帖获得了超过50万次转发。</p>
<p>面对质疑，导演孙十在微博回应称这些相似之处是对前辈作品的"致敬"和"学习"。但这一回应并未平息争议，反而激起了更大的反弹。多位电影评论人指出，"致敬和抄袭之间的界限在于是否有自己的原创表达。"</p>
<p>目前，部分网友已发起"抵制《暗夜追光》"的联名活动，呼吁片方在正式上映前对争议内容进行修改。影片发行方暂未对此事做出正式回应。</p>`,
    category: "exclusive",
    tags: ["孙十", "抄袭", "电影", "争议"],
    coverImageSeq: "cover-art-09",
    coverImagePrompt: "A minimalist side-by-side comparison of two film frames on a light table in a dark editing room, a magnifying loupe placed over the overlapping area revealing identical compositions, film strip negatives scattered around, dramatic focused task lighting, investigative and revealing atmosphere, editorial photography in cool tones with warm accent light, 4K quality, clean composition",
    thumbnailPrompt: "Side-by-side film frames on a light table with magnifying loupe revealing identical compositions, dark editing room with task lighting, investigative editorial atmosphere, cool tones with warm accent, clean composition",
    publishedAt: "2026-07-02T09:00:00Z",
    views: 6780000,
    comments: 46700,
    author: "电影侦探社",
    isHot: false,
    isBreaking: false,
  },
  {
    id: 10,
    slug: "host-huang-yi-divorce-drama",
    title: "金牌主持黄一一离婚大战升级，争夺10亿财产",
    summary: "知名主持人黄一一与妻子离婚案开庭，双方就超过10亿元的共同财产分割展开激烈争夺，庭审现场细节不断流出。",
    content: `<p>知名电视节目主持人黄一一与妻子林某的离婚案今日在北京市朝阳区人民法院开庭审理。据出庭人士透露，双方争议的核心是超过10亿元的共同财产如何分割。</p>
<p>黄一一与林某结婚12年，育有一子一女。据林某在法庭上陈述，黄一一在婚内存在多次不忠行为，且长期对家庭疏于照顾。而黄一一方面则称，林某在婚后挥霍无度，曾在一个月内花费2000万元购买奢侈品。</p>
<p>双方财产清单中包括北京、上海、三亚等地的7处房产、3辆豪车、多个公司股权以及大量现金存款，总估值超过10亿元人民币。林某主张获得70%的财产，黄一一则要求均分。</p>
<p>由于案件涉及金额巨大且双方社会关注度高，法院采取了不公开审理的方式。但庭审细节仍通过各方渠道不断流出，成为公众茶余饭后的热门话题。</p>`,
    category: "gossip",
    tags: ["黄一一", "离婚", "财产分割", "主持人"],
    coverImageSeq: "cover-art-10",
    coverImagePrompt: "A minimalist scene of a wedding photo frame face-down on a polished wooden table, a torn divorce document visible beside it, a gavel in the background slightly out of focus, soft window light creating gentle shadows, somber and reflective atmosphere, editorial photography in muted sepia and charcoal tones, emotional storytelling composition, 4K quality, clean simple setting",
    thumbnailPrompt: "A face-down wedding photo frame on polished wood table with divorce document beside it, gavel blurred in background, soft window light, somber editorial atmosphere, muted sepia and charcoal tones, emotional composition",
    publishedAt: "2026-07-01T15:00:00Z",
    views: 9340000,
    comments: 61200,
    author: "法庭直击记者",
    isHot: false,
    isBreaking: false,
  },
  {
    id: 11,
    slug: "tiktok-star-mao-er-underage-drinking",
    title: "未成年网红猫二被拍深夜酒吧狂欢，经纪公司紧急道歉",
    summary: "年仅16岁的短视频网红猫二被拍到深夜出入酒吧，与多名成年人饮酒狂欢。事件曝光后经纪公司紧急道歉，称将加强艺人管理。",
    content: `<p>年仅16岁的短视频网红猫二近日被拍到深夜出入北京三里屯某酒吧，与多名成年朋友饮酒狂欢至凌晨3点。照片中猫二手持酒杯，状态明显已经微醺。</p>
<p>猫二在短视频平台拥有超过500万粉丝，以清纯可爱的少女人设走红。此次酒吧照片的流出，与其一贯塑造的形象形成了强烈反差，迅速引发网络热议。</p>
<p>根据中国法律，酒吧等娱乐场所不得接纳未成年人进入，更不得向未成年人售酒。涉事酒吧已因违规接待未成年人被相关部门立案调查。</p>
<p>猫二所属的经纪公司"星辰互娱"今日发布道歉声明，承认对旗下艺人管理不善，表示将加强监管并配合相关部门调查。猫二本人的社交账号已停更，据称正在接受公司的内部教育和反省。</p>`,
    category: "wanghong",
    tags: ["猫二", "未成年", "酒吧", "网红"],
    coverImageSeq: "cover-art-11",
    coverImagePrompt: "A minimalist blurred nightclub interior seen through a rain-streaked window, colorful neon lights reflected and distorted on the wet glass, a cocktail glass silhouette visible through the blur, moody and mysterious night atmosphere, editorial photography with vibrant neon tones against dark background, urban and nocturnal feeling, 4K quality, clean abstract composition",
    thumbnailPrompt: "Blurred nightclub interior through rain-streaked window with neon reflections, cocktail glass silhouette, moody nocturnal atmosphere, vibrant neon tones against dark background, urban editorial style, clean composition",
    publishedAt: "2026-07-01T10:00:00Z",
    views: 11700000,
    comments: 83200,
    author: "吃瓜前线记者",
    isHot: false,
    isBreaking: false,
  },
  {
    id: 12,
    slug: "producer-qian-san-me-too",
    title: "知名制片人钱三被多名女演员指控性骚扰，行业震动",
    summary: "超过15名女演员先后发声，指控金牌制片人钱三在选角和工作过程中存在长期性骚扰行为。多家影视公司宣布终止与其合作。",
    content: `<p>一场席卷影视行业的"MeToo"风暴正在发酵。截至目前，已有超过15名女演员通过社交媒体公开发声，指控知名制片人钱三在选角和工作过程中存在长期的性骚扰行为。</p>
<p>第一位发声的女演员是在今日凌晨发布的长文，详细描述了钱三在2019年一部电视剧选角过程中对她进行的不当行为。随后，越来越多的受害者站出来分享自己的经历，形成了一个令人震惊的指控链条。</p>
<p>根据多位受害者的描述，钱三通常以"讨论剧本"或"单独试戏"为名，将女演员约到私密空间，然后进行言语和肢体上的骚扰。受害者普遍反映，由于钱三在行业内的影响力，当时不敢公开反抗。</p>
<p>事件发酵后，包括华策影视、正午阳光在内的多家知名影视公司已宣布终止与钱三的所有合作项目。中国电视剧制作产业协会也发表声明，表示将对此事展开调查。</p>`,
    category: "celebrity",
    tags: ["钱三", "性骚扰", "MeToo", "制片人"],
    coverImageSeq: "cover-art-12",
    coverImagePrompt: "A minimalist scene of a director's chair standing alone in an empty dark soundstage, a single spotlight beam illuminating the chair from above, the chair casting a long dramatic shadow, stark and powerful atmosphere, editorial photography in high contrast black and white, empty space conveying isolation and silence, cinematic composition, 4K quality",
    thumbnailPrompt: "A lone director's chair in an empty dark soundstage, single spotlight from above, long dramatic shadow, stark high contrast black and white, powerful editorial atmosphere, cinematic composition",
    publishedAt: "2026-06-30T22:00:00Z",
    views: 20100000,
    comments: 156000,
    author: "深度调查组",
    isHot: false,
    isBreaking: false,
  },
];

export const hotSearches = [
  { rank: 1, keyword: "张三造假塌房", heat: 9850000, articleId: 1 },
  { rank: 2, keyword: "李四隐婚富豪", heat: 8720000, articleId: 2 },
  { rank: 3, keyword: "王五涉毒被抓", heat: 8450000, articleId: 3 },
  { rank: 4, keyword: "赵六偷税2.8亿", heat: 7230000, articleId: 4 },
  { rank: 5, keyword: "周七出轨实锤", heat: 6890000, articleId: 5 },
  { rank: 6, keyword: "钱三性骚扰", heat: 6540000, articleId: 12 },
  { rank: 7, keyword: "陈八假慈善", heat: 5980000, articleId: 8 },
  { rank: 8, keyword: "吴九霸王条款", heat: 5210000, articleId: 6 },
  { rank: 9, keyword: "猫二未成年酒吧", heat: 4870000, articleId: 11 },
  { rank: 10, keyword: "综艺剧本操控", heat: 4320000, articleId: 7 },
];

export const siteInfo = {
  name: "黑料吃瓜",
  tagline: "每日追踪明星网红黑料、反差大瓜与独家爆料视频",
  description: "黑料吃瓜网站，每日追踪明星网红黑料、反差大瓜与独家爆料视频。黑料吃瓜网在线观看、黑料吃瓜爆料一网打尽，今日网红塌房现场实时更新，吃瓜第一线从这里开始。",
  keywords: "黑料吃瓜,黑料吃瓜网站,黑料吃瓜网在线观看,黑料吃瓜爆料,黑料吃瓜视频,今日黑料吃瓜,最新黑料吃瓜,网红黑料吃瓜视频,黑料吃瓜不打烊,黑料吃瓜入口,黑料吃瓜最新地址",
  domain: "https://heiliao-chigua.com",
  foundingDate: "2024-01-01",
  stats: {
    totalArticles: 12800,
    totalViews: 1500000000,
    celebrityCovered: 3200,
    dailyVisitors: 5000000,
  },
};